"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _subPackageOptions = require("../constants/subPackageOptions");

require("../styles/_modify-package.scss");

var _IncludedAddons = _interopRequireDefault(require("./IncludedAddons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function findDefaultValueFromOptions(value, options) {
  return options.find(function (option) {
    return option.value === value;
  });
}

function ModifyPackage(_ref) {
  var subPackage = _ref.subPackage,
      onUpdateField = _ref.onUpdateField,
      onModifyAddonsClick = _ref.onModifyAddonsClick;
  var isUnlimitedVideos = subPackage.videoQuantity === -1;
  return _react.default.createElement("div", {
    className: "modify-package"
  }, _react.default.createElement("div", {
    className: "modify-package__date"
  }, _react.default.createElement(_uiKit.DatePicker, {
    startDate: subPackage.subStart || void 0,
    endDate: subPackage.subEnd || void 0,
    onSelectStartDate: onUpdateField('subStart', {
      isString: true
    }),
    onSelectEndDate: onUpdateField('subEnd', {
      isString: true
    }),
    id: "sub-dates-picker",
    startLabel: "Start Date*",
    endLabel: "End Date*",
    initialDateFormat: "YYYY-MM-DDTHH:mm:ss.sssZ",
    openDown: true
  })), _react.default.createElement("div", {
    className: "modify-package__split-row"
  }, _react.default.createElement(_uiKit.NumberChanger, {
    value: subPackage.videoQuantity,
    hideValue: isUnlimitedVideos,
    label: "VIDEO CREDITS (PER PERIOD)*",
    onChangeNumber: onUpdateField('videoQuantity'),
    suffixLabel: isUnlimitedVideos ? 'UNLIMITED' : 'VIDEOS'
  }), _react.default.createElement(_uiKit.NumberChanger, {
    value: subPackage.amendmentsQuantity,
    label: "AMENDMENTS (PER PERIOD)*",
    onChangeNumber: onUpdateField('amendmentsQuantity'),
    suffixLabel: "CHANGES"
  })), _react.default.createElement(_uiKit.Dropdown, {
    label: "SLA TURNAROUND (HOURS)*",
    options: _subPackageOptions.SLA_TURNAROUND_OPTIONS,
    onChange: onUpdateField('slaTurnaround'),
    defaultValue: findDefaultValueFromOptions(subPackage.slaTurnaround, _subPackageOptions.SLA_TURNAROUND_OPTIONS)
  }), _react.default.createElement(_uiKit.Dropdown, {
    label: "STORAGE LIMIT (PER MONTH)*",
    options: _subPackageOptions.STORAGE_OPTIONS,
    onChange: onUpdateField('storageAllowance'),
    defaultValue: findDefaultValueFromOptions(subPackage.storageAllowance, _subPackageOptions.STORAGE_OPTIONS)
  }), _react.default.createElement(_uiKit.Dropdown, {
    label: "RESET PERIOD*",
    options: _subPackageOptions.RESET_PERIOD_OPTIONS,
    onChange: onUpdateField('resetPeriod', {
      isString: true
    }),
    defaultValue: findDefaultValueFromOptions(subPackage.resetPeriod, _subPackageOptions.RESET_PERIOD_OPTIONS)
  }), _react.default.createElement("div", {
    className: "modify-package__addons"
  }, _react.default.createElement("p", null, "Does this client have included Add-ons?"), _react.default.createElement(_uiKit.Button, {
    onClick: onModifyAddonsClick,
    small: true
  }, "MODIFY ADD-ONS")), _react.default.createElement(_IncludedAddons.default, {
    includedAddonTypes: subPackage.includedAddonTypes
  }));
}

var _default = (0, _react.memo)(ModifyPackage);

exports.default = _default;